var OCS = OCS || {};
OCS.Live = OCS.Live || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.is_workers_supported = function () {
    /* istanbul ignore next */
    if (typeof (window) !== 'undefined') {
        return !!window.Worker;
    } else {
        return false;
    }
};

OCS.Functions.is_service_workers_supported = function () {
    /* istanbul ignore next */
    if (typeof (navigator) !== 'undefined' && document && document.location.protocol === "https:") {
        return 'serviceWorker' in navigator;
    } else {
        return false;
    }
};

OCS.Functions.is_shared_workers_supported = function () {
    /* istanbul ignore next */
    if (typeof (window) !== 'undefined') {
        return !!window.SharedWorker;
    } else {
        return false;
    }
};

OCS.Functions.get_worker_manager = function (ops) {
    if (!OCS.Live.WorkerManager) {
        if (!ops) {
            ops = {};
        }
        new OCS.Classes.WorkerManager(ops);
    }
    return OCS.Live.WorkerManager;
};
